import { translate } from 'i18n/i18n'

export const modalDrawerTitleMaker = ({ isEditing, step }: { isEditing: boolean; step: number }) => {
  return isEditing
    ? translate.phrases.banyanApp('Edit View: Step {{step}} of {{totalSteps}}', { step, totalSteps: 3 })
    : translate.phrases.banyanApp('New View: Step {{step}} of {{totalSteps}}', { step, totalSteps: 3 })
}
